import React, { Component } from 'react';

export default class NotFound extends Component{
  render(){
    return(
      <div className="jumbotron text-center">
        <h1>404 Not Found</h1>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/views/404/NotFound.js